import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Text, CloseIcon, PlusIcon } from '@beef/ui-kit';

import style from './SharedZoneNewQuestion.module.pcss';

const cx = classNames.bind(style);

const SharedZoneNewQuestion = memo(({ title, description, onClick, isActive }) => (
  <li className={cx('question')}>
    {!!title && (
      <button
        onClick={onClick}
        className={cx('title')}
        name={isActive ? 'Закрыть' : 'Открыть'}
        type="button"
      >
        <Text size="size4-m">{title}</Text>
        {isActive ?
          <CloseIcon size="m" />
        : <PlusIcon size="m" />}
      </button>
    )}
    {isActive && !!description && (
      <div className={cx('description')}>
        <Text size="size5-r-l">{description}</Text>
      </div>
    )}
  </li>
));

export { SharedZoneNewQuestion };
